import DrawerComponent from 'shared/components/DrawerComponent'
import theme from 'shared/style/theme'
import { getPxAsRem } from 'shared/utils'
import CompanyDocumentUpload from './CompanyDocuments/CompanyDocumentUpload'
import { ContentWrapper } from './styled'

const CompanyDocumentsDrawer = ({ open, onClose, documents, refetch }) => {
    const baseStyle = {
        padding: getPxAsRem(28),
        borderWidth: 1,
        borderRadius: 2,
        borderColor: theme.palette.grey[300],
        borderStyle: 'dashed',
        backgroundColor: theme.palette.background.default,
        outline: 'none',
        transition: 'border .24s ease-in-out',
    }

    return (
        <DrawerComponent
            open={open}
            onClose={onClose}
            headerTitle="Documents"
            primaryActionText="Done"
            onPrimaryAction={onClose}
        >
            <ContentWrapper>
                <CompanyDocumentUpload
                    onClose={onClose}
                    documents={documents}
                    refetch={refetch}
                    baseStyle={baseStyle}
                />
            </ContentWrapper>
        </DrawerComponent>
    )
}

export default CompanyDocumentsDrawer
